<template>
  <vue-scroll>
    <div>
      <span class="subtitle2">Criticality</span>

      <span class="icon-criticality">
        <i
          class="display-block icon"
          :class="`icon-criticality-${hostDetails.criticality ? hostDetails.criticality.toLowerCase() : ''}`"
        ></i>
      </span>

      <span class="value">{{ hostDetails.criticality }}</span>
    </div>
    <div>
      <span class="subtitle2">OS</span>

      <span class="icon">
        <i :class="`fab fa-${hostDetails.system ? hostDetails.system.os.toLowerCase() : ''}`"></i>
      </span>
      <span class="value">{{ hostDetails.system ? hostDetails.system.os : '' }}</span>
    </div>
    <div>
      <span class="subtitle2">Platform</span>
      <span class="value">{{ hostDetails.system ? hostDetails.system.platform : '' }}</span>
    </div>
    <div>
      <span class="subtitle2">Release</span>
      <span class="value">{{ hostDetails.system ? hostDetails.system.release : '' }}</span>
    </div>
    <div>
      <span class="subtitle2">Version</span>
      <span class="value">{{ hostDetails.system ? hostDetails.system.version : '' }}</span>
    </div>
    <div>
      <span class="subtitle2">Status</span>
      <span>
        <span class="value">
          <el-tag :size="getStatusInfo.size" :color="getStatusInfo.color">{{ getStatusInfo.text }}</el-tag>
        </span>

        <!-- To be modified -->
        <!-- <span class="status_metadata">
          <span>No. of Iocs observed: 8</span>
          <span>Total Score: 455</span>
        </span>-->
      </span>
    </div>
    <div>
      <span class="subtitle2">Local IP</span>
      <span class="value">
        <span v-for="(ip, idx) in hostDetails.localIPs" :key="idx"> {{ ip }} <br /> </span>
      </span>
    </div>
    <div>
      <!-- <span class="subtitle2">Mac Address</span> -->

      <!-- To be modified -->
      <!-- <span class="value">
        08:00:27:45:c0:ad
      </span>-->
    </div>
    <div>
      <span class="subtitle2">Last Seen</span> <span class="value">{{ getLastSeen }}</span>
    </div>
    <!-- <div>
    <span class="subtitle2">Monitored since</span>-->

    <!-- To be modified -->
    <!-- <span class="value">{{getLastSeen}}</span> -->

    <!-- </div> -->
    <div>
      <span class="subtitle2">Agent</span>
      <span>
        <span class="value">
          <el-tag :size="getSensorInfo.size" :color="getSensorInfo.color">{{ getSensorInfo.text }}</el-tag>
        </span>

        <!-- To be modified -->
        <!-- <span class="status_metadata">
          <span>ID: 2.34.4556.8</span>
          <span>Version: 1.2</span>
        </span>-->
      </span>
    </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'HostDetailsFeed',
  props: {
    hostDetails: {
      default () {
        return {}
      },
      type: [Array, Object]
    }
  },
  data () {
    return {}
  },
  computed: {
    getLastSeen () {
      if (_.isEmpty(this.hostDetails)) {
        return ''
      }
      const timeStamp = new Date(this.hostDetails.agentDetails.createTime)
      const timeStampArr = timeStamp.toString('MMM dd').split(' ')
      const date = `${timeStampArr[1]} ${timeStampArr[2]}, ${timeStampArr[3]}  ${timeStamp.toLocaleTimeString('en-US')}`
      return date
    },
    getStatusInfo () {
      if (_.isEmpty(this.hostDetails)) {
        return {
          text: '',
          color: '',
          size: ''
        }
      }
      let statusText, statusColor
      let statusSize = 'medium'
      if (
        this.hostDetails.agentDetails.agentStatus === 'ONLINE' &&
        this.hostDetails.agentDetails.aggregatedRiskScore === 0
      ) {
        statusText = 'SAFE'
        statusColor = '#e1f2ff'
      } else if (
        this.hostDetails.agentDetails.agentStatus === 'ONLINE' &&
        this.hostDetails.agentDetails.aggregatedRiskScore > 0
      ) {
        statusText = 'At Risk'
        statusColor = '#feebee'
      } else {
        statusText = 'OFFLINE'
        statusColor = '#f8f8f8'
      }

      return {
        text: statusText,
        color: statusColor,
        size: statusSize
      }
    },
    getSensorInfo () {
      if (_.isEmpty(this.hostDetails)) {
        return {
          text: '',
          color: '',
          size: ''
        }
      }
      let sensorText, sensorColor
      let sensorSize = 'medium'
      if (this.hostDetails.agentDetails.agentStatus === 'ONLINE') {
        sensorText = 'ON'
        sensorColor = '#e9ffcc'
      } else {
        sensorText = 'OFF'
        sensorColor = '#f8f8f8'
      }

      return {
        text: sensorText,
        color: sensorColor,
        size: sensorSize
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/icon.css';

section {
  height: calc(100%-160px);
}

div {
  display: flex;
  flex-wrap: nowrap;
  padding: 8px;

  &:first-of-type {
    border-top: 1px solid var(--border-color);
    margin-top: 10px;
    padding-top: 24px;
  }

  .value {
    flex-grow: 1;
    align-self: auto;
    max-width: 50%;
  }

  .subtitle2 {
    flex-grow: 1;
    align-self: auto;
    max-width: 27%;
    padding: 0px 0px 0px 20px;
    margin: 0px 16px 0px 0px;
  }

  .icon {
    background: none;
    margin: 0px 10px 0px 0px;
    font-size: 16px;
    color: var(--aluminum-600);
  }

  .icon-criticality {
    .icon {
      background: var(--aluminum-600);
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .status_metadata {
    display: grid;
    margin: 16px 0px 0px 0px;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/feed/HostDetailsFeed.vue